module.exports = __webpack_public_path__ + "img/arcanum.473d5d13.jpg";